import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Box, Stack, Typography } from "@mui/material";
import { money } from "@/utils/numeral/money";
import { ResourceDetailsCoverageTabDataGridCommitmentIdCellRenderer } from "@/components/pages/common/resource-details/components/content/coverage-content/components/data-grid/ResourceDetailsCoverageTabDataGridCommitmentIdCellRenderer";

export const resourceDetailsCoverageTabDataGridColumnDefs: ColDef[] = [
  {
    field: "commitment.provider_id",
    headerName: "Commitment ID",
    cellRenderer: ResourceDetailsCoverageTabDataGridCommitmentIdCellRenderer,
  },
  {
    field: "coverage",
    headerName: "Commitment Covers",
    cellRenderer: ({ value }: ICellRendererParams) => {
      return (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          width="100%"
          minWidth={100}
        >
          <Box
            flexGrow={1}
            bgcolor="grey.300"
            height={10}
            borderRadius={2}
            overflow="hidden"
          >
            <Box bgcolor="info.main" width={`${value}%`} height={10} />
          </Box>

          <Typography variant="body2" color="info.main">
            {value?.toFixed(2)} %
          </Typography>
        </Stack>
      );
    },
  },
  {
    field: "covered_usage",
    headerName: "Spend Covered by Commitment",
    cellRenderer: ({ value }: ICellRendererParams) => {
      return <Typography variant="body2">{money(value)}</Typography>;
    },
  },

  {
    field: "commitment.type",
    headerName: "Type",
    cellRenderer: ({ value }: ICellRendererParams) => {
      return (
        <Typography variant="body2">
          {value === "savings_plan" ? "Savings Plan" : "Reserved Instances "}
        </Typography>
      );
    },
  },
  {
    field: "net_savings",
    headerName: "Net Savings",
    cellRenderer: ({ value }: ICellRendererParams) => {
      return <Typography variant="body2">{money(value)}</Typography>;
    },
  },
];
